// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[id^="erxes-container"] {
  z-index: 1000000000;
  border: none;
}

[id^="erxes-container"] > iframe {
  border: none;
}

/*loader*/
[data-erxes-embed] {
  position: relative;
  background: rgba(0, 0, 0, 0.03);
  border-radius: 4px;
  box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.03);
}

.hidden {
  display: none !important;
}

@media only screen and (max-width: 420px) {
  [id^="erxes-container"] {
    width: 100%;
    max-height: none;
  }

  [id^="erxes-iframe"] {
    bottom: 0;
    right: 0;
  }
}

.erxes-modal-iframe {
  position: fixed; /* Stay in place */
  z-index: 1000000; /* Sit on top */
  left: 0;
  top: 0;
  bottom: 0;
  min-width: 100%; /* Full width */
  border: none;
  height: 100% !important;
}

.erxes-slide-right-iframe,
.erxes-slide-left-iframe {
  position: fixed;
  bottom: 5px;
  border-radius: 10px;
  width: 380px;
  max-height: 100%;
  max-height: calc(100% - 10px);
  animation-delay: 1s;
  -webkit-animation-delay: 1s;
  -webkit-animation-duration: 0.3s;
  animation-duration: 0.3s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  box-shadow: 0 3px 20px 0px rgba(0, 0, 0, 0.3);
  overflow: hidden;
}

/* slide in left */
.erxes-slide-left-iframe {
  left: 5px;
  animation: fadeInLeft 0.3s;
  -webkit-animation: fadeInLeft 0.3s;
}

/* slide in right */
.erxes-slide-right-iframe {
  right: 5px;
  animation: fadeInRight 0.3s;
  -webkit-animation: fadeInRight 0.3s;
}

/* embeded form */
.erxes-embedded-iframe {
  position: initial !important;
  margin: 0 auto;
  height: 100%;
  border-radius: 4px;
  box-shadow: 0 3px 18px -2px rgba(0, 0, 0, 0.2);
}

/* dropdown */
.erxes-dropdown-iframe {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  animation-delay: 1s;
  -webkit-animation-delay: 1s;
  animation: fadeInDown;
  -webkit-animation: fadeInDown;
  -webkit-animation-duration: 0.3s;
  animation-duration: 0.3s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  max-height: 100%;
  box-shadow: 0 3px 20px -2px rgba(0, 0, 0, 0.3);
}

/* shoutbox */
.erxes-shoutbox-iframe {
  position: fixed;
  bottom: 0px;
  right: 0px;
  width: 416px;
  height: 100%;
  max-height: 100%;
  max-height: calc(100% - 10px);
}

.erxes-shoutbox-iframe.erxes-hidden {
  width: 96px;
}

/* animations */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes fadeInDown {
  from {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

.fadeInDown {
  -webkit-animation-name: fadeInDown;
  animation-name: fadeInDown;
}

@-webkit-keyframes fadeInLeft {
  from {
    opacity: 0;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes fadeInLeft {
  from {
    opacity: 0;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

.fadeInLeft {
  -webkit-animation-name: fadeInLeft;
  animation-name: fadeInLeft;
}

@-webkit-keyframes fadeInRight {
  from {
    opacity: 0;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes fadeInRight {
  from {
    opacity: 0;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

.fadeInRight {
  -webkit-animation-name: fadeInRight;
  animation-name: fadeInRight;
}
`, "",{"version":3,"sources":["webpack://./client/form/widget/index.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,SAAS;IACT,QAAQ;EACV;AACF;;AAEA;EACE,eAAe,EAAE,kBAAkB;EACnC,gBAAgB,EAAE,eAAe;EACjC,OAAO;EACP,MAAM;EACN,SAAS;EACT,eAAe,EAAE,eAAe;EAChC,YAAY;EACZ,uBAAuB;AACzB;;AAEA;;EAEE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,2BAA2B;EAC3B,gCAAgC;EAChC,wBAAwB;EACxB,iCAAiC;EACjC,yBAAyB;EACzB,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,SAAS;EACT,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA,mBAAmB;AACnB;EACE,UAAU;EACV,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA,iBAAiB;AACjB;EACE,4BAA4B;EAC5B,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA,aAAa;AACb;EACE,eAAe;EACf,OAAO;EACP,QAAQ;EACR,MAAM;EACN,mBAAmB;EACnB,2BAA2B;EAC3B,qBAAqB;EACrB,6BAA6B;EAC7B,gCAAgC;EAChC,wBAAwB;EACxB,iCAAiC;EACjC,yBAAyB;EACzB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA,aAAa;AACb;EACE,eAAe;EACf,WAAW;EACX,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA,eAAe;AACf;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2CAA2C;IAC3C,mCAAmC;EACrC;;EAEA;IACE,UAAU;IACV,uCAAuC;IACvC,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,UAAU;IACV,2CAA2C;IAC3C,mCAAmC;EACrC;;EAEA;IACE,UAAU;IACV,uCAAuC;IACvC,+BAA+B;EACjC;AACF;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE;IACE,UAAU;IACV,2CAA2C;IAC3C,mCAAmC;EACrC;;EAEA;IACE,UAAU;IACV,uCAAuC;IACvC,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,UAAU;IACV,2CAA2C;IAC3C,mCAAmC;EACrC;;EAEA;IACE,UAAU;IACV,uCAAuC;IACvC,+BAA+B;EACjC;AACF;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE;IACE,UAAU;IACV,0CAA0C;IAC1C,kCAAkC;EACpC;;EAEA;IACE,UAAU;IACV,uCAAuC;IACvC,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,UAAU;IACV,0CAA0C;IAC1C,kCAAkC;EACpC;;EAEA;IACE,UAAU;IACV,uCAAuC;IACvC,+BAA+B;EACjC;AACF;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B","sourcesContent":["[id^=\"erxes-container\"] {\n  z-index: 1000000000;\n  border: none;\n}\n\n[id^=\"erxes-container\"] > iframe {\n  border: none;\n}\n\n/*loader*/\n[data-erxes-embed] {\n  position: relative;\n  background: rgba(0, 0, 0, 0.03);\n  border-radius: 4px;\n  box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.03);\n}\n\n.hidden {\n  display: none !important;\n}\n\n@media only screen and (max-width: 420px) {\n  [id^=\"erxes-container\"] {\n    width: 100%;\n    max-height: none;\n  }\n\n  [id^=\"erxes-iframe\"] {\n    bottom: 0;\n    right: 0;\n  }\n}\n\n.erxes-modal-iframe {\n  position: fixed; /* Stay in place */\n  z-index: 1000000; /* Sit on top */\n  left: 0;\n  top: 0;\n  bottom: 0;\n  min-width: 100%; /* Full width */\n  border: none;\n  height: 100% !important;\n}\n\n.erxes-slide-right-iframe,\n.erxes-slide-left-iframe {\n  position: fixed;\n  bottom: 5px;\n  border-radius: 10px;\n  width: 380px;\n  max-height: 100%;\n  max-height: calc(100% - 10px);\n  animation-delay: 1s;\n  -webkit-animation-delay: 1s;\n  -webkit-animation-duration: 0.3s;\n  animation-duration: 0.3s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n  box-shadow: 0 3px 20px 0px rgba(0, 0, 0, 0.3);\n  overflow: hidden;\n}\n\n/* slide in left */\n.erxes-slide-left-iframe {\n  left: 5px;\n  animation: fadeInLeft 0.3s;\n  -webkit-animation: fadeInLeft 0.3s;\n}\n\n/* slide in right */\n.erxes-slide-right-iframe {\n  right: 5px;\n  animation: fadeInRight 0.3s;\n  -webkit-animation: fadeInRight 0.3s;\n}\n\n/* embeded form */\n.erxes-embedded-iframe {\n  position: initial !important;\n  margin: 0 auto;\n  height: 100%;\n  border-radius: 4px;\n  box-shadow: 0 3px 18px -2px rgba(0, 0, 0, 0.2);\n}\n\n/* dropdown */\n.erxes-dropdown-iframe {\n  position: fixed;\n  left: 0;\n  right: 0;\n  top: 0;\n  animation-delay: 1s;\n  -webkit-animation-delay: 1s;\n  animation: fadeInDown;\n  -webkit-animation: fadeInDown;\n  -webkit-animation-duration: 0.3s;\n  animation-duration: 0.3s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n  max-height: 100%;\n  box-shadow: 0 3px 20px -2px rgba(0, 0, 0, 0.3);\n}\n\n/* shoutbox */\n.erxes-shoutbox-iframe {\n  position: fixed;\n  bottom: 0px;\n  right: 0px;\n  width: 416px;\n  height: 100%;\n  max-height: 100%;\n  max-height: calc(100% - 10px);\n}\n\n.erxes-shoutbox-iframe.erxes-hidden {\n  width: 96px;\n}\n\n/* animations */\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@-webkit-keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@-webkit-keyframes fadeInDown {\n  from {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0);\n  }\n}\n\n@keyframes fadeInDown {\n  from {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0);\n  }\n}\n\n.fadeInDown {\n  -webkit-animation-name: fadeInDown;\n  animation-name: fadeInDown;\n}\n\n@-webkit-keyframes fadeInLeft {\n  from {\n    opacity: 0;\n    -webkit-transform: translate3d(-100%, 0, 0);\n    transform: translate3d(-100%, 0, 0);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0);\n  }\n}\n\n@keyframes fadeInLeft {\n  from {\n    opacity: 0;\n    -webkit-transform: translate3d(-100%, 0, 0);\n    transform: translate3d(-100%, 0, 0);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0);\n  }\n}\n\n.fadeInLeft {\n  -webkit-animation-name: fadeInLeft;\n  animation-name: fadeInLeft;\n}\n\n@-webkit-keyframes fadeInRight {\n  from {\n    opacity: 0;\n    -webkit-transform: translate3d(100%, 0, 0);\n    transform: translate3d(100%, 0, 0);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0);\n  }\n}\n\n@keyframes fadeInRight {\n  from {\n    opacity: 0;\n    -webkit-transform: translate3d(100%, 0, 0);\n    transform: translate3d(100%, 0, 0);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0);\n  }\n}\n\n.fadeInRight {\n  -webkit-animation-name: fadeInRight;\n  animation-name: fadeInRight;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
